import { createStore } from 'vuex'
import { FilterMatchMode } from 'primevue/api'

export default createStore({
  state: {
    selectedCategory: 'all',
    selectedEmpTypeGroups: ['Tillsvidare', 'Visstid', 'Säsong'],
    filters: {
      global: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS
      }
    }
  },

  getters: {},

  mutations: {
    setSelectedCategory (state, selectedCategory) {
      state.selectedCategory = selectedCategory
    },

    setSelectedEmpTypeGroups (state, selectedEmpTypeGroups) {
      state.selectedEmpTypeGroups = selectedEmpTypeGroups
    },

    setFilters (state, filters) {
      state.filters = filters
    }
  },

  actions: {
    sendPostMessageFrameHeight (context, scrollToTop = false) {
      window.parent.postMessage({
        frameHeight: document.getElementById('app').offsetHeight + 50,
        scrollToTop: scrollToTop
      }, '*')
    },

    sendPostMessageJobId (context, jobId) {
      window.parent.postMessage({
        jobId: jobId
      }, '*')
    },

    sendPostMessageClearJobId (context) {
      window.parent.postMessage({
        clearJobId: true
      }, '*')
    },

    sendPostMessageCategory (context, categoryName) {
      window.parent.postMessage({
        category: categoryName
      }, '*')
    },

    sendPostMessageFilter (context, filterValue) {
      window.parent.postMessage({
        filterValue: filterValue
      }, '*')
    }
  },

  modules: {}
})
